import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EnquiryListComponent } from './components/enquiry-list/enquiry-list.component';
import { EnquiryDetailComponent } from './components/enquiry-detail/enquiry-detail.component';
import { NewEnquiryComponent } from './components/new-enquiry/new-enquiry.component';
import { NewEnquiryBulkComponent } from './components/new-enquiry-bulk/new-enquiry-bulk.component';
import { HomeComponent } from './components/home/home.component';
import { ToastrModule } from 'ngx-toastr';
import { TokenInterceptor } from './interceptors/api-key.interceptor';
import { InfiniteScrollDirective} from 'ngx-infinite-scroll';
import { ProfileComponent } from './components/profile/profile/profile.component';
import { ChangePasswordComponent } from './components/profile/change-password/change-password.component';
import { LoadingComponent } from './components/loading/loading.component';
import { EmptyScreenComponent } from './components/empty-screen/empty-screen.component';
import { OrderPlacedComponent } from './components/order-placed/order-placed.component';
import { PurchaseReturnModalComponent } from './components/purchase-return-modal/purchase-return-modal.component';
import { ChatModalComponent } from './components/chat-modal/chat-modal.component';
import { AttachmentModalComponent } from './components/attachment-modal/attachment-modal.component';
import { VerifyAccessComponent } from './components/verify-access/verify-access.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { SavedAddressesComponent } from './components/profile/saved-addresses/saved-addresses.component';
import { NewAddressComponent } from './components/profile/saved-addresses/new-address/new-address.component';
import { ConfirmDialogComponent } from './components/shared/confirm-dialog/confirm-dialog.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationFormComponent } from './components/application-form/application-form.component';
import { EnrolmentFormComponent } from './components/enrolment-form/enrolment-form.component';
import { RequestFormComponent } from './components/request-form/request-form.component';
import { AddressSelectionModalComponent } from './components/shared/address-selection-modal/address-selection-modal.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { LocationModalComponent } from './components/shared/location-modal/location-modal.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AddAddressModalComponent } from './components/shared/add-address-modal/add-address-modal.component';
import { TermsComponent } from './components/terms/terms.component';
import { OtpModalComponent } from './components/shared/otp-modal/otp-modal.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RegenerateItemModalComponent } from './components/shared/regenerate-item-modal/regenerate-item-modal.component';
import { WhatsAppConsentComponent } from './components/whatsapp-consent/whatsapp-consent.component';
import { SimpleEnquiryComponent } from './components/simple-enquiry/simple-enquiry.component';
import { SimpleEnquiryDetailComponent } from './components/simple-enquiry-detail/simple-enquiry-detail.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    EnquiryListComponent,
    EnquiryDetailComponent,
    NewEnquiryComponent,
    NewEnquiryBulkComponent,
    HomeComponent,
    ProfileComponent,
    ChangePasswordComponent,
    LoadingComponent,
    EmptyScreenComponent,
    OrderPlacedComponent,
    PurchaseReturnModalComponent,
    ChatModalComponent,
    AttachmentModalComponent,
    VerifyAccessComponent,
    AccessDeniedComponent,
    SavedAddressesComponent,
    NewAddressComponent,
    ConfirmDialogComponent,
    ApplicationFormComponent,
    EnrolmentFormComponent,
    RequestFormComponent,
    AddressSelectionModalComponent,
    LocationModalComponent,
    AddAddressModalComponent,
    TermsComponent,
    OtpModalComponent,
    RegenerateItemModalComponent,
    WhatsAppConsentComponent,
    SimpleEnquiryComponent,
    SimpleEnquiryDetailComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    InfiniteScrollDirective,
    NgbPopoverModule,
    NgOtpInputModule,
    GoogleMapsModule,
    BsDatepickerModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
